module.exports = __webpack_public_path__ + "static/media/golf1alert.282be00e.jpg";